import React, { useContext } from 'react'
import { LiabilitiesContext } from '../../context'
import { Spotlight } from '@components/Spotlight'
import Box from '@material-ui/core/Box'

export const LiabilityTotals = () => {
  const { state } = useContext(LiabilitiesContext)
  const { totalRepayments, totalLiability } = state
  return (
    <Box
      component='section'
      px='3rem'
      my='1rem'
      display='flex'
      justifyContent='space-between'
    >
      <Spotlight
        value={totalLiability}
        description='Total Liability'
      />
      <Spotlight
        value={totalRepayments}
        description='Total Monthly Repayments'
      />
    </Box>
  )
}
